import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import Constants from "../../../../common/Constants";
import MasterList from "../../../common/MasterList";
import ModalBody from "../../../common/ModalBody";
import ModalHeader from "../../../common/ModalHeader";

const ViewVerifiedChecklist = (props) => {
  //const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  // const handleClose = () => {
  //   setOpen(false);
  // };
  // const handleOpen = (data) => {
  //   setOpen(true);
  // };
  const columnsData = [
    {
      name: t("msg_master_list.msg_checklist.code"),
      selector: (row) => row.checklistCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.checklistCode} </p>
        </div>
      ),
    },
    {
      name: t("msg_master_list.msg_checklist.name"),
      selector: (row) => row.checklistName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">{row.checklistName} </p>
        </div>
      ),
    },
    {
        name: t("msg_master_list.msg_checklist.checklistType"),
        selector: (row) => row.checklistTypeName,
        sortable: true,
        width: "200px",
        cell: (row) => (
          <div>
            <p className="m-0 p-0 pt-1 fw-datatable-row">{row.checklistTypeName} </p>
          </div>
        ),
      },
      {
        name: t("msg_common.verified"),
        selector: (row) => row.verified,
        sortable: true,
        width: "150px",
        cell: (row) => (
          <>
            {row.verified === true ? (
              <span className="bg-table-status bg-table-success-status">
                {t("msg_common.complete")}
              </span>
            ) : row.verified === false ? (
              <span className="bg-table-status bg-table-danger-status">
                {t("msg_common.Incomplete")}
              </span>
            ) : (
              <span className="bg-table-status bg-table-danger-status">
                {t("msg_common.Incomplete")}
              </span>
             )}
          </>
        ),
      },
  ];
  const { onHide } = props;
  // console.log(">>>>>>>>>", props);
  return (
    <Modal {...props} onHide={onHide} animation={false} size="xl" backdrop="static" >
      <ModalHeader
        title={` ${t("msg_reports.msg_operator_checklist.verified_checklist")}`}
      ></ModalHeader>
      <ModalBody>
        <MasterList
          columnsData={columnsData}
          rowsData={props.rowsData}
          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
          pagination
          selectableRows={false}
          handleClose
          cardHeader={false}
          //handleOpen={handleOpen}
          //handleDelete={confirmBeforeDelete}
          //onSelectedRowsChange={handleRowSelected}
        />
      </ModalBody>
    </Modal>
  );
};

export default ViewVerifiedChecklist;
